export function getmobileinfo() {
  var w = document.body.clientWidth;
  let pixel_ratio = window.devicePixelRatio;
  var h = document.documentElement.clientHeight;
  var device_type = navigator.userAgent; //获取userAgent信息
  var MobileDetect = require("mobile-detect");
  var md = new MobileDetect(navigator.userAgent);
  var os = md.os();
  let brand = md.mobile(); //获取系统
  let ua = navigator.userAgent.toLowerCase();
  let mobile = new Object();
  mobile.device = device_type;
  mobile.os = os;
  mobile.name = brand;
  mobile.width = w;
  mobile.height = h;
  mobile.pixel = pixel_ratio;
  return JSON.stringify(mobile)
}

// export function colorFn(color, val = "#000") {
//   color.includes('linear') ? val : color
// }